/**
 * Configuration dictionary for colors
 * @type {Object}
 * @category Configuration
 */
const colors = {
    white: '#ffffff',
    black: '#000000',
    darkgray: '#1a1a1a',
    gray: '#2b2b2b',
    buttongray: '#f5f5f5',
    lightgray: '#d8d8d8',
    yellow: '#FFCE00',
    red: '#EC1E24',
    lightblue: '#A1E1E3',
    strongOrange: '#F16622',
    orange: '#F37E44',
    skyblue: '#c1ebeb',
    blue: '#007bff',
    teal: '#00575c',
    // orange: '#f37e43',
    pink: '#e83e8c',
    pairedColors: {
      count: ['#1f78b4', '#33a02c', '#e31a1c', '#ff7f00', '#6a3d9a', '#b15928'],
      sum: ['#a6cee3', '#b2df8a', '#fb9a99', '#fdbf6f', '#cab2d6', '#ffff99'],
    },
    qualtitiveScaleLight: [
      '#a6cee3',
      '#1f78b4',
      '#b2df8a',
      '#33a02c',
      '#fb9a99',
      '#e31a1c',
      '#fdbf6f',
      '#ff7f00',
      '#cab2d6',
      '#6a3d9a',
      '#ffff99',
      '#b15928'
    ],
    qualtitiveScaleDark: [
      '#8dd3c7',
      '#ffffb3',
      '#bebada',
      '#fb8072',
      '#80b1d3',
      '#fdb462',
      '#b3de69',
      '#fccde5',
      '#d9d9d9',
      '#bc80bd',
      '#ccebc5',
      '#ffed6f',
    ],
    dotDensity: [
      [],
      [68, 187, 153], // American Indian or Alaska Native
      [238, 136, 102], // Asian
      [119, 170, 221], // Black or African American
      [187, 204, 51], // Hispanic or Latino
      [187, 187, 187], // Native Hawaiian or Other Pac. Islander
      [153, 221, 255], // Other
      [255, 255, 255], // Two or more
      [255, 170, 187], // White
    ],
  };
  export default colors;